import { useEffect, useState } from 'react'

const clearData = (dataInitial) => {
    const dataReturned = {
        ...dataInitial,

        ...(dataInitial.disparo1Tajo?.trim().toUpperCase() === 'SIN -'
            ? {
                disparo1Tajo: '',
                disparo1Check: false
            }
            : {}),

        ...(dataInitial.disparo2Tajo?.trim().toUpperCase() === 'DISP ARO'
            ? {
                disparo2Tajo: '',
                disparo2Check: false
            }
            : {}),
    };

    return dataReturned;
};

const useFormPanel = (initialForm = {}, setIndexButton) => {
    // console.log("initialForm -> ", initialForm)
    // console.log("setIndexButton -> ", setIndexButton)
    const [indexData, setIndexData] = useState(initialForm.IndexData)
    const [formState, setformState] = useState(clearData(initialForm))

    useEffect(() => {
        // console.log(initialForm);
        const cleanedForm = clearData(initialForm);
        // console.log(cleanedForm);
        const newIndex = initialForm?.IndexData;
        if (newIndex !== indexData) {
            setIndexData(newIndex);
            setformState(cleanedForm);
            setIndexButton(0);
        }
    }, [initialForm]);

    const onInputChange = (target) => {
        const [key, value] = Object.entries(target)[0];
        setformState((prev) => ({
            ...prev,
            [key]: value,
        }));
    }
    return {
        formState,
        onInputChange
    };
}

export default useFormPanel